import {
  Map as ImmutableMap,
  List as ImmutableList,
  fromJS,
} from 'immutable'
import {
  LINK_FETCH_REQUEST,
  LINK_FETCH_SUCCESS,
  LINK_FETCH_FAIL,
  IMPORT_LINK_CARDS,
  POPULAR_LINKS_FETCH_REQUEST,
  POPULAR_LINKS_FETCH_SUCCESS,
  POPULAR_LINKS_FETCH_FAIL,
  ENTITY_LINKS_FETCH_REQUEST,
  ENTITY_LINKS_FETCH_SUCCESS,
  ENTITY_LINKS_FETCH_FAIL,
} from '../actions/links'

const initialState = ImmutableMap({
  isFetched: false,
  isLoading: false,
  items: ImmutableMap(),
  popular: ImmutableMap({
    isLoading: false,
    isFetched: false,
    items: ImmutableList(),
  }),
  group: ImmutableMap(),
  chat_conversation: ImmutableMap(),
})

const onRequest = (state, path) => {
  // if deeply nested (i.e. with id) doesn't exist, setIn instead
  const exists = !!state.getIn([...path], null)

  if (exists) {
    return state.updateIn([...path], (map) => {
      return map
        .set('isLoading', true)
        .set('isFetched', false)
        .set('isError', false)
    })
  } else {
    return state.setIn([...path], ImmutableMap({
      items: ImmutableList(),
      next: null,
      isLoading: true,
      isError: false,
      isFetched: false,
    }))
  } 
}

const onSuccess = (state, path, cards, next) => {
  state = state.withMutations((mutable) => {
    cards.forEach((card) => {
      mutable.setIn(['items', `${card.id}`], fromJS(card))
    })
  })

  return state.updateIn([...path], (map) => {
    return map
      .set('next', next)
      .set('isLoading', false)
      .set('isError', false)
      .set('isFetched', true)
      .update('items', (list) => {
        // if doesn't have any more to add, just return same
        if (!Array.isArray(cards)) return list
        
        // unique
        let n = list.concat(cards.map(item => `${item.id}`))
        n = Array.from(new Set(n))
        return fromJS(n)
      })
  })
}

const onFail = (state, path) => {
  return state.withMutations((mutable) => {
    mutable.setIn([...path, 'isLoading'], false)
    mutable.setIn([...path, 'isFetched'], true)
    mutable.setIn([...path, 'next'], null)
    mutable.setIn([...path, 'items'], ImmutableList())
  })
}

export default function links(state = initialState, action) {
  switch(action.type) {
  case LINK_FETCH_REQUEST:
    return state.set('isLoading', true)
  case LINK_FETCH_SUCCESS:
    return state.withMutations((mutable) => {
      mutable.setIn(['items', `${action.card.id}`], fromJS(action.card))
      mutable.set('isLoading', false)
      mutable.set('isFetched', false)
    })
  case IMPORT_LINK_CARDS:
    return state.withMutations((mutable) => {
      action.cards.forEach((card) => mutable.setIn(['items', `${card.id}`], fromJS(card)))
      mutable.set('isLoading', false)
      mutable.set('isFetched', false)
    })
  case LINK_FETCH_FAIL:
    return state.withMutations((mutable) => {
      mutable.set('isLoading', false)
      mutable.set('isFetched', false)
    })
  case POPULAR_LINKS_FETCH_REQUEST:
    return onRequest(state, ['popular'])
  case POPULAR_LINKS_FETCH_SUCCESS:
    return onSuccess(state, ['popular'], action.cards)
  case POPULAR_LINKS_FETCH_FAIL:
    return onFail(state, ['popular'])

  case ENTITY_LINKS_FETCH_REQUEST:
    return onRequest(state, [action.key, action.id])
  case ENTITY_LINKS_FETCH_SUCCESS:
    return onSuccess(state, [action.key, action.id], action.cards, action.next)
  case ENTITY_LINKS_FETCH_FAIL:
    return onFail(state, [action.key, action.id])

  default:
    return state
  }
}

